// extracted by mini-css-extract-plugin
export default {"icon":"UserDetailsDrawer_icon__WPd9H"};